import React, { Component } from "react";
import PropTypes from "prop-types";
import { Provider } from "react-redux";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import { Route } from "react-router-dom";
import App from "./App.jsx";
import { ConnectedRouter } from "react-router-redux";
import languageExchangeMUITheme from "../languageExchangeMUITheme";
import injectTapEventPlugin from "react-tap-event-plugin";
import createGenerateClassName from "material-ui/styles/createGenerateClassName";
import { I18nextProvider } from "react-i18next";

import JssProvider from "react-jss/lib/JssProvider";
import { create } from "jss";
import preset from "jss-preset-default";
import i18n from "../i18n"; // initialized i18next instance

const jss = create(preset());
// Custom Material-UI class name generator for better debug and performance.
jss.options.createGenerateClassName = createGenerateClassName;

injectTapEventPlugin();

class Root extends Component {
    render() {
        const { store, history } = this.props;
        return (
            <Provider store={store}>
                <MuiThemeProvider theme={languageExchangeMUITheme()}>
                    <JssProvider jss={jss}>
                        <I18nextProvider i18n={i18n}>
                            <ConnectedRouter history={history}>
                                <div>
                                    <Route path="/" component={App} />
                                </div>
                            </ConnectedRouter>
                        </I18nextProvider>
                    </JssProvider>
                </MuiThemeProvider>
            </Provider>
        );
    }
}

Root.propTypes = {
    store: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
};

export default Root;



// WEBPACK FOOTER //
// ./src/containers/Root.jsx